import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { ButtonComponent, Color, Variant } from '@mode/capra';
import { SharedUtilSegmentModule, TrackClickData } from '@mode/shared/util-segment';
import { CommonModule } from '@angular/common';
import { ClipboardDirective } from '../clipboard/clipboard.directive';

@Component({
  standalone: true,
  selector: 'mode-copy-input',
  imports: [CommonModule, ButtonComponent, ClipboardDirective, SharedUtilSegmentModule],
  templateUrl: './copy-input.component.html',
  styleUrls: ['./copy-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CopyInputComponent implements OnInit {
  @Input() link = '';
  @Input() buttonVariant: Variant = 'primary';
  @Input() disabled = false;
  @Input() trackCopyClick: TrackClickData | undefined;

  private readonly _buttonColorRecord: Record<Variant, Color> = {
    primary: 'default',
    secondary: 'neutral',
  };

  public buttonColor = this._buttonColorRecord[this.buttonVariant];

  @HostBinding('class')
  public hostClass = 'mode-copy-input';

  ngOnInit(): void {
    this.buttonColor = this._buttonColorRecord[this.buttonVariant];
  }
}
